// To differentiate environments we use this variable passed in Package.json
export const env = import.meta.env.MODE;
export const isProd = import.meta.env.MODE === 'production';

const configList = {
  development: {
    CURRENT_ENV: env,
    API_BASE_URL: 'http://localhost:8000/api',
    VEEFIN_DASHBOARD_URL: 'https://scfuat.fincobox.com',
    GTM_ID: '',
  },
  staging: {
    CURRENT_ENV: env,
    API_BASE_URL: 'https://uat-api.fincobox.com/api',
    VEEFIN_DASHBOARD_URL: 'https://scfuat.fincobox.com',
    GTM_ID: '',
  },
  production: {
    CURRENT_ENV: env,
    API_BASE_URL: 'https://api.fincobox.com/api',
    VEEFIN_DASHBOARD_URL: 'https://veefin.fincobox.com',
    GTM_ID: 'GTM-M49C6FMR',
  },
};

export const APP_CONFIG = configList[env || 'development'];

export default APP_CONFIG;
